import { UAParser } from "ua-parser-js";
import type { PageViewPayload } from "@/services/view";
import type { PageType } from "#shared/types";
import { parseValue } from "#shared/utils/session";

export function getUserAgent(pageType?: PageType): PageViewPayload {
  const ua = new UAParser().getResult();
  return {
    pageType: pageType as PageType || '',
    platform: ua.device.type || 'desktop',
    browser: ua.browser.name || '',
    browserVersion: ua.browser.version || '',
    osName: ua.os.name || '',
    osVersion: ua.os.version || '',
    deviceModel: ua.device.model || '',
    deviceVendor: ua.device.vendor || ''
  };
}

export function getSessionCookiesOnClient() {
  return Object.values(COOKIE).reduce((acc, cookie) => {
    acc[cookie] = parseValue(getClientCookie(cookie) || '');
    return acc;
  }, {} as Record<COOKIE, string | boolean | number | any[]>);
}

export function triggerRouteChange(routeName: string) {
  if (import.meta.client) {
    window.parent.postMessage({ route: routeName }, '*');
  }
}
